import { Component } from '@angular/core';
import { GridShapeComponent } from '../../../shared/components/common/grid-shape/grid-shape.component';
import { RouterModule } from '@angular/router';
import { ThemeToggleTwoComponent } from '../../../shared/components/common/theme-toggle-two/theme-toggle-two.component';

@Component({
  selector: 'app-pending-user',
  imports: [
    GridShapeComponent,
    RouterModule,
    ThemeToggleTwoComponent
  ],
  templateUrl: './pending-user.component.html',
  styleUrl: './pending-user.component.css',
})
export class PendingUserComponent {
  currentYear: number = new Date().getFullYear();
}
